var _path, _linearGradient, _path2, _linearGradient2, _path3, _path4, _linearGradient3, _path5, _linearGradient4, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboardCalender = function SvgDashboardCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 80.5"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#afafaf",
    d: "M7.6 12.4C3.4 12.4 0 15.8 0 20v52.9c0 4.2 3.4 7.6 7.6 7.6h53c4.2 0 7.6-3.4 7.6-7.6V20c0-4.2-3.4-7.6-7.6-7.6h-53z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "959-a",
    x1: 34.006,
    x2: 34.178,
    y1: 41.713,
    y2: 113.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#959-a)",
    d: "M7.6 8.7C3.4 8.7 0 12.1 0 16.2v52.9c0 4.2 3.4 7.6 7.6 7.6h53c4.2 0 7.6-3.4 7.6-7.6V16.2c0-4.2-3.4-7.6-7.6-7.6h-53z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "959-b",
    x1: 33.894,
    x2: 34.066,
    y1: 5.255,
    y2: 28.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a1343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a1343"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#959-b)",
    d: "M7.6 5.7C3.4 5.7 0 9.1 0 13.2v15.1h68V13.2c0-4.2-3.4-7.6-7.6-7.6H7.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.1c0 3.1-2.5 5.7-5.7 5.7s-5.7-2.5-5.7-5.7 2.5-5.7 5.7-5.7S17 12 17 15.1zm45.3 0c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7s2.5-5.7 5.7-5.7 5.7 2.6 5.7 5.7z",
    className: "st3"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "959-c",
    x1: 11.336,
    x2: 11.336,
    y1: 1.643,
    y2: 16.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9C"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#959-c)",
    d: "M11.3 0C9.2 0 7.6 1.5 7.6 3.8v11.4c0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8V3.8C15.1 1.5 13.4 0 11.3 0z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "959-d",
    x1: 56.681,
    x2: 56.681,
    y1: 1.643,
    y2: 16.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#959-d)",
    d: "M56.7 0c-2.1 0-3.8 1.5-3.8 3.8v11.4c0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8V3.8c0-2.3-1.7-3.8-3.8-3.8z"
  })));
};
export default SvgDashboardCalender;